export default "__VITE_ASSET__BUSOjdVw__"